export default {
  unlock_crucial_information: 'Unlock crucial information and turn insight into strategy',
  dashboard: 'Dashboard',
  dashboard_overview: 'Dashboard Overview',
  add_chart: 'Add Chart​',
  data_type: 'Data Type',
  source: 'Data Source',
  date: 'Date',
  frequency: 'Frequency',
  chart_type: 'Chart Type',
  cancel: 'Cancel',
  close: 'Close',
  add: 'Add',
  data_info: 'Detail​',
  setting: 'Setting',
  delete: 'Delete',
  information: 'Information',
  chart_name: 'Chart Name',
  description: 'Description',
  filter: 'Filter',
  filters: 'Filters',
  add_tab: 'Add Tab',
  tab_name: 'Tab Name',
  fill: 'Fill Name​',
  All: 'All',
  PieChart: 'Pie Chart',
  LineChart: 'Line Chart',
  BarChart: 'Bar Chart',
  Heatmap: 'Heat Map',
  Infographic: 'Infographic Chart',
  Radar: 'Radar Chart',
  Box: 'Box Chart',
  GeoMap: 'Geo Chart',
  Table: 'Table',
  Gauge: 'Gauge Chart',
  Overview: 'Overview',
  Profile: 'Profile',
  Customer: 'Customer',
  Product: 'Product',
  Transaction: 'Transaction',
  POS: 'POS',
  CRM: 'CRM',
  Csv: 'CSV',
  CRMPOS: 'CRM/POS',
  BP: 'BCRM Platform',
  FH5: 'Fasthelp5',
  edit_tab: 'Edit Tab',
  save: 'Save',
  no_filter: 'No Filter',
  selected: 'Selected',
  select: 'Select',
  setting_chart: 'Setting Chart',
  chart_info:'Chart Info',
  color: 'Color',
  no_color: 'No Color',
  apply: 'Apply',
  confirm_deletion: 'Confirm deletion',
  or_not: 'or not',
  confirm: 'Confirm',
  no_item: 'No item',
  search: 'Search',
  reset: 'Reset',
  select_source: 'Select Data Source​',
  startDate: 'Start Date',
  endDate: 'End Date',
  fillDataSourceAndDate: 'Please fill the correct source and date',
  successful: 'Successful',
  success: 'success',
  want_to_delete_tab: 'Are you sure you want to delete',
  yes_no: '?',
  create_tab: 'Create a new tab',
  change_tab_name: 'Change tab name',
  tab_name_to: 'to',
  tab_list_empty: 'Tab list empty',
  not_found_tab_item: 'Not found tab item',
  overview: 'Overview',
  geomap_extraleft_title: 'Top 5 Provinces',
  total: 'Total',
  no_data: 'No Data',
  export_pdf: 'Export PDF',
  date_range: 'Date Field',
  background: 'Background',
  label: 'Label',
  female: 'Female',
  male: 'Male',
  not_specified: 'Not-Specified',
  children: 'Child',
  teenager: 'Teenager',
  young_adult: 'Young Adult',
  early_career: 'Early Career',
  mid_career: 'Mid Career',
  mature_adult: 'Mature Adult',
  senior: 'Senior',
  child: 'Child',
  teen: 'Teen',
  late_teen: 'Late Teen',
  working: 'Working',
  old: 'Old',
  age: 'Age',
  year_over: 'Year over',
  dynamicFilter: 'Dynamic Filter',
  seemore: 'See More',
  chart: 'Chart',
  brandAndBranch: 'Brand and Branch',
  pleaseSelectBrand: 'Please select brand and branch to display the chart',
  download_success: 'Download successful',
  download_failed: 'Download failed',
  downloading: 'Downloading',
  download_date: 'Download Date',
  time: 'Time',
};
